import { api } from '../core';

export type DocumentAssignCaseResponse = {
  documentId: string;
};

type DocumentAssignCaseProps = {
  unassignedDocumentId: string;
  caseId: string;
};

const documentAssignCaseApi = api.injectEndpoints({
  endpoints: (builder) => ({
    postDocumentAssignCase: builder.query<DocumentAssignCaseResponse, DocumentAssignCaseProps>({
      query: ({ unassignedDocumentId, caseId }: DocumentAssignCaseProps) => ({
        url: `document/assign-case`,
        method: 'POST',
        body: {
          unassignedDocumentId: unassignedDocumentId,
          caseId: caseId
        }
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (error) {
          console.error('Error in postDocumentAssignCase in onQueryStarted:', error);
        }
      },
      extraOptions: { maxRetries: 0 }
    })
  })
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyPostDocumentAssignCaseQuery } = documentAssignCaseApi;
